module.exports = __webpack_public_path__ + "static/img/case_banner_11.2fb692c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_11.png
// module id = TDd+
// module chunks = 34